<div *ngIf="availableSettings; else loadingTemplate" class="setting-selector">
    <ng-select [items]="availableSettings" bindLabel="label" (change)="onSelection($event)">
    </ng-select>
</div>

<ng-template #loadingTemplate>
    <div class="spinner-border">
        <span class="visually-hidden">Loading...</span>
    </div>
</ng-template>
